// extracted by mini-css-extract-plugin
export default {"color_nhsuk_pale_yellow":"#fff9c4","color_nhsuk_yellow":"#ffeb3b","nhsuk_text_color":"#212b32"};